/*
*   File : strategy-detail.js
*   Author : https://evoqins.com
*   Description : Basket detail page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';
import { addDays } from 'date-fns';


//Custom components
import { Breadcrumbs, Chip, CustomRadioButton, Loader, OverLay } from '../../Component/Others';
import { Icon } from '../../Component/Icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../Component/Buttons';
import { ConnectBrokerModal, SubscriptionStatusModal, WhySubscriptionModal } from '../../Component/Modal';
import { Holdings, Overview, Performance } from './helper';
import { CustomAmountInput, CustomDatePicker, CustomTextInput } from '../../Component/FormElements';
import { _checkBrokerStatus, _formatSIPDate, _getBasketDetail, _getBrokersList, _getMarketStatus, _scrollToTop, _validateBroker, BROKERS_LIST_DATA } from '../../Helper';
import { APIService } from '../../Service';

//Style
import style from "../../Styles/Component/basket.module.scss";
import Colors from "../../Styles/color.scss";


const BREADCRUMBS = [
    {
        id: 1,
        label: "Explore",
        path: "/explore",
        data: {
            category_tab: 1,
        },
    },
    {
        id: 2,
        label: "Products",
        path: "/explore",
        data: {
            category_tab: 1,
        },
    },
];

const TAB_DATA = [
    {
        id: 1,
        label: "Overview",
        icon: require("../../Assets/Images/Other/overview.svg").default
    },
    {
        id: 2,
        label: "Performance",
        icon: require("../../Assets/Images/Other/performance.svg").default
    },
    {
        id: 3,
        label: "Holdings",
        icon: require("../../Assets/Images/Other/holdings.svg").default
    },
];

const HOW_IT_WORKS = [
    {
        title: "KYC Verification",
        description: "Provide your PAN card details to verify if you are a KYC user."
    },
    {
        title: "Subscribe to the Basket",
        description: "Pay ₹499 to subscribe and gain access to exclusive investment baskets."
    },
    {
        title: "Start Your Investments",
        description: "After subscribing, investment options will be enabled, allowing you to start investing in curated baskets."
    }
];


const SIP_AMOUNT = [
    {
        id: 1,
        amount: 1000
    },
    {
        id: 2,
        amount: 2000
    },
    {
        id: 3,
        amount: 3000
    },
];

// const SHARE_ITEMS = [
//     {
//         label: "Email",
//         icon: require("../../Assets/Images/Modal/email-icon.svg").default,
//     },
//     {
//         label: "WhatsApp",
//         icon: require("../../Assets/Images/Modal/whatsapp.svg").default,
//     },
//     {
//         label: "Facebook",
//         icon: require("../../Assets/Images/Modal/facebook.svg").default,
//     },
//     {
//         label: "Instagram",
//         icon: require("../../Assets/Images/Modal/instagram.svg").default,
//     },
//     {
//         label: "Twitter",
//         icon: require("../../Assets/Images/Modal/twitter.svg").default,
//     },
//     {
//         label: "LinkedIn",
//         icon: require("../../Assets/Images/Modal/linkedIn.svg").default,
//     },
// ];

const BasketDetail = () => {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const navigate = useNavigate();
    const { state } = useLocation();
    let connected_broker = JSON.parse(localStorage.getItem("indvestment_connected_broker"));

    const [basketData, setBasketData] = useState({});
    const [portfolioData, setPortfolioData] = useState({});
    const [basketHoldings, setBasketHoldings] = useState([]);
    const [tabIndex, setTabIndex] = useState(1);
    const [breadcrumbs, setBreadCrumbs] = useState(BREADCRUMBS);
    const [subscription, setSubscription] = useState(false);
    const [selectedInvestmentType, setSelectedInvestmentType] = useState(state && state.investment_amount ? 2 : 1);
    const [sipAmount, setSipAmount] = useState("");
    const [sipAmountError, setSipAmountError] = useState("");
    const [selectedAmountChip, setSelectedAmountChip] = useState(null)
    const [selectedDate, setSelectedDate] = useState(null);
    const [sipDateError, setSipDateError] = useState("");
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [totalAmount, setTotalAmount] = useState("");
    const [totalAmountError, setTotalAmountError] = useState("");
    const [bookmark, setBookmark] = useState(false);
    const [bookmarkText, setBookmarkText] = useState(false);
    const [toggleShare, setToggleShare] = useState(false);
    const [link, setLink] = useState("");
    const [linkError, setLinkError] = useState("");
    const [holdingsBreakdownData, setHoldingsBreakdownData] = useState("");
    const [chartData, setChartData] = useState("");
    const [holdingsLoader, setHoldingsLoader] = useState(true);
    const [performanceLoader, setPerformanceLoader] = useState(true);
    const [cagrPerformance, setCagrPerformance] = useState([]);
    const [showWhySubscriptionModal, setShowWhySubscriptionModal] = useState(false);
    const [selectedPlanID, setSelectedPlanID] = useState(1);
    const [investmentType, setInvestmentType] = useState([]);


    const [isSIPDue, setIsSIPDue] = useState(false);
    const [disableStartSIP, setDisableStartSIP] = useState(false);


    const [sipLoader, setSIPLoader] = useState(false);
    const [loader, setLoader] = useState(false);
    const [howItWorks, setHowItWork] = useState(false);
    const [showBrokerConnectModal, setShowBrokerConnectModal] = useState(false);
    const [subscriptionModal, setSubscriptionModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);
    // const [investMentData, setInvestmentData] = useState({});
    const [executedBroker, setExecutedBroker] = useState({});
    const [bookMarkLoader, setBookMarkLoader] = useState(false);
    const [repairHoldings, setRepairHoldings] = useState([]);

    useEffect(() => {
        // API call
        if (state && state.strategy_id) {
            _getBasketData(state.strategy_id, USER_DATA.unique_identifier, state.tenant_id);
        } else {
            toast.dismiss();
            toast.error("No data found");
            navigate("/explore");
        }

        // Scroll the page to top
        _scrollToTop();

    }, []);

    useEffect(() => {
        if (tabIndex !== 1 && basketData && basketData.strategy_id) {
            if (tabIndex === 2 && chartData === "") {
                setPerformanceLoader(true);
                _getPerformanceChartData();
            }

            if (tabIndex === 3 && holdingsBreakdownData === "") {
                setHoldingsLoader(true);
                _getHoldingsBreakdownChartData();
            }
        }
    }, [tabIndex, basketData]);

    useEffect(() => {
        if (basketData && basketData.strategy_id) {
            // Portfolio Id is required to call this API
            if (basketData.portfolio_id) {
                _getPortfolioHoldings();
            }

            // Broker connected for Lumpsum invest resume the invest flow
            if (state && state.investment_amount) {
                setLoader(true);
                // setSelectedInvestmentType(2);
                setTotalAmount(state.investment_amount);
                _callGetMarketStatus();
            };
        }

    }, [basketData]);

    useEffect(() => {
        if (portfolioData && portfolioData.strategy_id) {
            // Getting executed broker data
            _getBrokersList().then((response) => {
                if (response.status_code === 200) {
                    let executed_broker = response.data.find((broker) => broker.broker_name === portfolioData.execution_partner);
                    setExecutedBroker(executed_broker);
                }
            });
        }
    }, [portfolioData]);

    useEffect(() => {
        if (state && state.tab_id) {
            setTabIndex(state.tab_id);
        } else {
            setTabIndex(1);
        }
    }, [state]);

    useEffect(() => {
        if (subscriptionModal === true) {
            const subscription_modal = new Modal(document.getElementById('subscription-modal'));
            subscription_modal.show();
        }
    }, [subscriptionModal]);

    useEffect(() => {
        if (showBrokerConnectModal === true) {
            const broker_connect_modal = new Modal(document.getElementById('connect-modal'));
            broker_connect_modal.show();
        }
    }, [showBrokerConnectModal]);

    useEffect(() => {
        if (showWhySubscriptionModal === true) {
            const why_subscription_modal_info = new Modal(document.getElementById('why-subscription-modal'));
            why_subscription_modal_info.show();
        }
    }, [showWhySubscriptionModal]);

    useEffect(() => {
        setSipAmountError("");
    }, [sipAmount]);

    useEffect(() => {
        setTotalAmountError("");
    }, [totalAmount]);

    useEffect(() => {
        setLinkError("");
    }, [link, toggleShare]);

    // handle tab  
    const _handleTab = (id) => {
        navigate("/explore/strategy-detail", {
            state: {
                tab_id: id,
                strategy_id: state.strategy_id
            }
        });
    };

    // handle open and close sip date picker
    const _handleToggleSIPDatePicker = () => {
        setShowDatePicker((prev) => !prev);
    };

    // handle SIP date select
    const _handelSIPDateSelect = (date) => {
        setShowDatePicker(false);
        setSelectedDate(date);
        setSipDateError("");
    };

    // handle close the date pick dropdown
    const _handleCloseDatePicker = () => {
        setShowDatePicker(false);
    };

    // handle clear the selected date
    const _handleClearDate = () => {
        setSelectedDate(null);
    };


    // handle toggle how it works 
    const _handleToggle = () => {
        setHowItWork(prev => !prev);
    };

    // handle select product type
    const _handleSelectInvestmentType = (id) => {
        setSelectedInvestmentType(id);
        setSelectedAmountChip(null);
    };

    // handle SIP amount change
    const _handleSIPAmountChange = (value) => {
        setSipAmount(value);
    };

    // handle select sip amount 
    const _handleSelectAmount = (type, selected) => {
        if (type === 1) {
            setSipAmount(prevAmount => Number(prevAmount) + Number(selected.amount));
            setSelectedAmountChip(selected.id);
        } else {
            setTotalAmount(prevAmount => Number(prevAmount) + Number(selected.amount));
            setSelectedAmountChip(selected.id);
        }
    };

    // handle bookmark 
    const _handleBookmark = () => {

        setBookMarkLoader(true);

        // API call
        if (bookmark) {
            _removeFromWatchList();
        } else {
            _addToWatchList();
        }
    };

    // handle toggle share 
    const _handleToggleShare = () => {
        setToggleShare(prev => !prev);
    };

    // handle copy link 
    // const _handleCopyLink = () => {
    //     if (link.trim().length === 0) {
    //         setLinkError("Please provide link");
    //     } else {
    //         navigator.clipboard.writeText(link);
    //     }
    // };

    // handle navigate - breadcrumbs
    const _handleNavigate = (data) => {

        if (data.path) {
            navigate(data.path, {
                state: {
                    "category_tab": data.data.category_tab,
                }
            });
        }
    };

    // handle subscribe 
    const _handleSubscribe = () => {
        navigate("/explore/create-subscription", {
            state: {
                strategy_data: JSON.stringify(basketData),
                plan_id: selectedPlanID,
            }
        });
    };

    // handle verifyKYC
    const _handleVerifyKYC = () => {
        navigate("/explore/create-subscription", {
            state: {
                strategy_data: JSON.stringify(basketData),
                plan_id: selectedPlanID
            }
        });
    };

    // handle select plan
    const _handleSelectPlan = (selected_plan_id) => {
        setSelectedPlanID(selected_plan_id);
    };

    // handle close broker connect modal
    const _handleCloseConnectModal = () => {
        setShowBrokerConnectModal(false);
        setSIPLoader(false);
        setLoader(false);
    };

    // handle navigate to broker connect page
    const _handleNavigateToBrokerConnect = () => {
        //  Navigate to connect broker 
        navigate("/account/connect-broker", {
            state: {
                strategy_id: basketData.strategy_id,
                is_new_connection: selectedInvestmentType == 2 && basketData.executed === false ? true : false,
                investment_amount: totalAmount
            }
        });
    };

    // handle connect broker - connecting already executed broker
    const _handleConnectExecutedBroker = () => {

        toast.dismiss();
        toast.error(`Please connect with the same broker, you used previously to place order (${portfolioData.execution_partner})`);

        // Open broker connect window
        setTimeout(() => {
            let broker_connect_window = window.open(executedBroker.url, "_blank");
            let access_token = "";
            let interval = setInterval(() => {
                try {
                    let current_url = broker_connect_window.location.href;
                    let url_data = current_url.split('?');
                    if (url_data.length !== 1) {
                        // Taking the token from the URL
                        let params = new URLSearchParams(url_data[1]);
                        let access_token_name = BROKERS_LIST_DATA.find(broker => broker.broker_name === executedBroker.broker_name).access_token_name;
                        access_token = params.get(access_token_name);
                        clearInterval(interval);
                        broker_connect_window.close();

                        _validateBroker(executedBroker, access_token, USER_DATA.unique_identifier).then(response => {
                            if (response.status_code === 200) {
                                // Saving connected Broker info
                                localStorage.setItem("indvestment_connected_broker", JSON.stringify(response.data));
                                // API call - Checking market status 
                                _callGetMarketStatus();
                            } else {
                                toast.dismiss();
                                toast.error(response.message);
                            }
                        })
                    }
                } catch (error) {
                    console.log("Cross-origin access error. Waiting for the window to navigate...");
                }

                if (broker_connect_window.closed) {
                    clearInterval(interval);
                    if (!access_token) {
                        setLoader(false);
                        setSIPLoader(false);
                    }
                }

            }, 1000);
        }, 500);
    };

    // handle invest 
    const _handleInvest = () => {

        let is_valid = true;

        if (selectedInvestmentType === 1) {

            // Alert toast message for SIP if not invested in lumpsum
            if (basketData.executed === false) {
                toast.dismiss();
                toast.error("To start a SIP, invest in this basket in lumpsum");
                return;
            }

            if (sipAmount.length === 0) {
                setSipAmountError("Enter SIP amount");
                is_valid = false;
            } else if (sipAmount < Number(basketData.sip_min_amount)) {
                setSipAmountError(`Min investment amount is ₹${Number(basketData.sip_min_amount).toLocaleString("en-IN")}`);
                is_valid = false;
            } else if (basketData.sip_max_amount && sipAmount > Number(basketData.sip_max_amount)) {
                setSipAmountError(`Max investment amount is ₹${Number(basketData.sip_max_amount).toLocaleString("en-IN")}`);
                is_valid = false;
            } else if (portfolioData.sip_details && sipAmount < portfolioData.sip_details.amount) {
                setSipAmountError(`SIP  due is ₹${portfolioData.sip_details.amount.toLocaleString("en-IN")}`);
                is_valid = false;
            }

            if (isSIPDue === false && selectedDate === null) {
                setSipDateError("Select day of sip");
                is_valid = false;
            }

        } else {

            if (totalAmount.length === 0) {
                setTotalAmountError("Enter total amount");
                is_valid = false;
            } else if (totalAmount < basketData.min_investment) {
                setTotalAmountError(`Min investment amount is ₹${basketData.min_investment.toLocaleString("en-IN")}`);
                is_valid = false;
            }
        }

        if (is_valid === true) {

            let is_new_broker_connected = localStorage.getItem("indvestment_is_lumpsum_broker");

            // Create SIP Portfolio
            if (selectedInvestmentType === 1 && basketData.executed && isSIPDue === false) {
                setSIPLoader(true); // SIP
                _createNewSIPPortfolio();
                return;
            }

            // Create Lumpsum Invest || Invest more || SIP due
            // Checking broker connection - Fresh Investment
            if (basketData.executed === false && (is_new_broker_connected === "false" || connected_broker === null)) {
                // Open broker connect modal
                setShowBrokerConnectModal(true);
            } else {
                // broker connected - Lumpsum 
                if (basketData.executed === false) {
                    setLoader(true); // for lumpsum
                    // API call
                    _callGetMarketStatus();
                } else if (connected_broker === null || (connected_broker.broker_name.toLowerCase() !== portfolioData.execution_partner.toLowerCase())) {

                    if (selectedInvestmentType === 1) {
                        setSIPLoader(true); // SIP
                    } else {
                        setLoader(true); // Invest more
                    }
                    toast.dismiss();
                    toast.error(`Please connect with the same broker, you used previously to place order (${portfolioData.execution_partner})`);
                    // Connect executed broker
                    _handleConnectExecutedBroker();

                } else {
                    if (selectedInvestmentType === 1) {
                        setSIPLoader(true); // SIP Due
                    } else {
                        setLoader(true); // for lumpsum
                    }
                    // API call - Checking market status 
                    _callGetMarketStatus();
                }
            }
        }
    };


    // ===================================== //
    // ============ API CALLS ============== //

    // Get basket detail 
    const _getBasketData = async (strategy_id, user_id, tenant_id) => {

        _getBasketDetail(strategy_id, user_id, tenant_id).then(response => {
            if (response.status_code === 200) {

                setBasketData(response.data);
                setBasketHoldings(response.data.holdings);
                setSubscription(response.data.is_subscribed);

                setInvestmentType([{ id: 2, label: "Lumpsum" }]);
                setTotalAmount(response.data.min_investment);
                setBookmark(response.data.is_watchlisted);
                setBreadCrumbs([...BREADCRUMBS,
                {
                    id: 3,
                    label: "alphaBasket",
                    path: "/explore",
                    data: {
                        category_tab: response.data.strategy_type === "alpha-basket-pro" ? 2 : 1,
                    },
                },
                {
                    id: 4,
                    label: response.data.strategy_name,
                    path: null,
                    data: null
                },]);

                // Enabling SIP investment
                if (response.data.sip_flag) {
                    setInvestmentType([
                        { id: 1, label: "SIP" },
                        { id: 2, label: "Lumpsum" },
                    ]);
                    setSipAmount(response.data.sip_min_amount);

                    // Checking SIP status - in Due or not
                    _checkSIPEligibility(response.data);

                } else {
                    setSelectedInvestmentType(2);
                }


                // Pre selecting subscribed plan
                let subscribed_plan_id = response.data.subscribed_plan?.id || null;
                if (subscribed_plan_id) {
                    setSelectedPlanID(subscribed_plan_id);
                } else {
                    setSelectedPlanID(response.data.pricing_information[0].id);
                }

            } else {
                toast.dismiss();
                toast.error("No data found");
                navigate("/explore", {
                    state: {
                        "category_tab": state.category_tab,
                    }
                });
            }
            setDataLoading(false);
        })
    };

    // Get holdings breakdown chart detail 
    const _getHoldingsBreakdownChartData = async () => {

        let url = "products/sectorial-weight";
        let data = {
            "strategy_id": state.strategy_id,
            "strategy_type": basketData.strategy_type,
            "user_id": USER_DATA.unique_identifier,
            "tenant_id": basketData.creator_info.creator_id
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setHoldingsBreakdownData(response.data);
        } else {
            setHoldingsBreakdownData("");
        }

        setHoldingsLoader(false);
    };

    // Get holdings breakdown chart detail - Tab 2
    const _getPerformanceChartData = async () => {

        let url = "products/graph";
        let data = {
            "strategy_id": state.strategy_id,
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            let labels = response.data.slice(0, 1).flatMap((item => item.data.map(item => item.date)));
            let data_sets = response.data.filter(item => item.name == "Index Value" || item.name == "Portfolio Value");
            data_sets = data_sets.sort((item_1, item_2) => item_1.name.localeCompare(item_2.name)).map((item => item.data.map(item => Number(item.value))))

            setChartData({
                labels: labels,
                // Portfolio data
                dataset1: data_sets[1],
                // Index data
                dataset2: data_sets[0]

            });

            await _getCAGRPerfromanceData();
        } else {
            toast.dismiss();
            toast.error("No data found");
            setChartData("");
            setPerformanceLoader(false);
        }

    };

    // Get holdings breakdown chart detail - Tab 2
    const _getCAGRPerfromanceData = async () => {

        let url = "products/annual-performance";
        let data = {
            "strategy_id": Number(state.strategy_id),
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setCagrPerformance(response.data[0]);
        }
        setPerformanceLoader(false);
    };

    // Add basket to the watchList
    const _addToWatchList = async () => {

        let url = "portfolio/watchlist/add";
        let data = {
            "strategy_id": Number(basketData.strategy_id),
            "tenant_id": Number(basketData.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            toast.dismiss();
            toast.success(basketData.strategy_name + " added to the watchlist successfully");

            setBookmark(true);
            setBookmarkText(true);
            setTimeout(() => {
                setBookmarkText(false);
            }, 3000);

        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setBookMarkLoader(false);
    };

    //  Remove basket to the watchlist
    const _removeFromWatchList = async () => {
        let url = "portfolio/watchlist/remove";
        let data = {
            "strategy_id": Number(basketData.strategy_id),
            "tenant_id": Number(basketData.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            toast.dismiss();
            toast.success(basketData.strategy_name + " removed from the watchlist successfully");
            setBookmark(false);
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setBookMarkLoader(false);
    };

    // Call get Market status
    const _callGetMarketStatus = async () => {

        let connected_broker = JSON.parse(localStorage.getItem("indvestment_connected_broker"));
        const response = await _getMarketStatus();

        if (response.status_code === 200) {
            if (response.data.market_status === "Open") {
                // API => Validate connected broker
                _checkBrokerStatus(connected_broker, USER_DATA.unique_identifier).then(response => {
                    if (response.status_code === 200) {

                        // Updating connected Broker info
                        let updated_broker_data = {
                            ...connected_broker,
                            available_cash: response.data.available_cash,
                        };

                        localStorage.setItem("indvestment_connected_broker", JSON.stringify(updated_broker_data));

                        // Updating broker connect after initiating investment
                        localStorage.setItem("indvestment_is_lumpsum_broker", false);

                        navigate("invest", {
                            state: {
                                investmentType: selectedInvestmentType == 1 ? "SIP" : "LUMPSUM",
                                lumpsum: totalAmount,
                                sip: sipAmount,
                                portfolio_id: basketData.portfolio_id,
                                basket_data: basketData,
                                holdings_data: selectedInvestmentType == 1 ? portfolioData.current_holdings : basketHoldings,
                                operation: selectedInvestmentType == 1 ? "SIP_PURCHASE" : basketData.executed ? "ADDITIONAL_PURCHASE" : "NEW_PURCHASE",
                                is_sip_due: isSIPDue
                            }
                        });
                    } else {
                        // Connecting executed broker
                        _handleConnectExecutedBroker();
                    }
                })
            } else {
                toast.dismiss();
                toast.error("Market closed, you can't make order today");
            }
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setLoader(false);
        setSIPLoader(false);
    };

    // Check SIP eligibility
    const _checkSIPEligibility = async (basket_data) => {

        let url = "portfolio/eligible-for-sip";
        let data = {
            "strategy_id": basket_data.strategy_id,
            "tenant_id": Number(basket_data.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier
        };

        let response = await APIService(url, data)
        if (response.status_code === 200) {
            setIsSIPDue(response.data.sip_flag);
        } else {
            setSIPLoader(false);
        }

    };

    // Create SIP portfolio
    const _createNewSIPPortfolio = async () => {
        let url = "portfolio/create-sip";
        let data = {
            "amount": Number(sipAmount),
            "email_id": USER_DATA.email,
            "execution_partner": portfolioData.execution_partner,
            "portfolio_id": basketData.portfolio_id,

            "duration": 12,
            "sip_start_date": new Date(selectedDate),
            "sip_type": "Monthly",

            "strategy_name": basketData.strategy_name,
            "strategy_id": Number(basketData.strategy_id),
            "tenant_id": Number(basketData.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier,
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            toast.dismiss();
            toast.success("SIP created successfully");

            // Check SIP Status
            _checkSIPEligibility(basketData);

            // Disable SIP start button
            _getPortfolioHoldings();
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setSIPLoader(false);
    };

    // Get portfolio holdings data
    const _getPortfolioHoldings = async () => {
        let url = "portfolio/details";
        let data = {
            "page_num": 1,
            "tenant_id": Number(basketData.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier,
            "strategy_id": basketData.strategy_id,
            "portfolio_id": basketData.portfolio_id,
            "portfolio_type": "Basket",
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setPortfolioData(response.data);

            // SIP created - Disable Start SIP button if not in due
            setDisableStartSIP(response.data.sip_details && response.data.sip_details.created_on && response.data.sip === false); // true ==> SIp due not else later

            // Adding stock id to basket holdings for invest more flow
            let updated_basket_holdings = basketData.holdings.map(holding => {
                let matching_holding = response.data.current_holdings.find(item => item.alphaniti_key === holding.alphaniti_key);
                if (matching_holding) {
                    return {
                        ...holding,
                        "portfolio_stock_id": matching_holding.portfolio_stock_id,
                        "portfolio_order_id": matching_holding.portfolio_order_id,
                        "portfolio_action_id": matching_holding.portfolio_action_info?.portfolio_action_id
                    }
                } else {
                    return holding
                }
            });

            setBasketHoldings(updated_basket_holdings);

            // Repair orders list
            let unfilled_holdings = response.data.current_holdings.filter((holding) => holding.unfilled_quantity > 0);
            setRepairHoldings(unfilled_holdings);
        }
    };

    return (
        <>
            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <section className={`${style.e_basket_detail_wrapper} pb-5`}>
                        {/* Bread crumbs */}
                        <Breadcrumbs data={breadcrumbs} handleNavigate={_handleNavigate}
                            className="padding-14px-tb px-sm-2" />
                        {/* Top banner */}
                        <div className={`${style.e_top_section} border-radius-16 p-3`}>
                            <div className='row flex-nowrap flex-column flex-md-row row-gap-3'>
                                <div className='col col-md-3 d-flex flex-row flex-md-column justify-content-between'>
                                    <div className="d-flex flex-row flex-md-column gap-2 gap-sm-3 gap-md-0">
                                        <img src={basketData.strategy_icon}
                                            draggable={false}
                                            className='w-64px w-36px-res w-48px-res bg-white p-1 border-radius-8'
                                            alt='product' />
                                        <div>
                                            <h6 className='text-wrap e-font-16-res mb-1 my-sm-2 e-alt-font-lato e-text-white e-font-18 e-font-weight-600 line-height-24px'>
                                                {basketData.strategy_name}
                                            </h6>
                                            <div className={`${style.e_category_chip} e-padding-4px-tb-res d-flex align-items-center padding-6px-tb px-2 gap-2 e-bg-white border-radius-24 w-max-content`}>
                                                <img src={require("../../Assets/Images/Card/basket-icon.svg").default}
                                                    draggable={false}
                                                    className='w-16px-res w-20px '
                                                    alt='tag' />
                                                <span className='e-font-12-res e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                    {basketData.strategy_type || "alphaBasket"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Bookmarks and share for mobile screen */}
                                    <div className='d-flex d-md-none gap-2 align-items-center justify-content-end'>
                                        {/* bookmark */}
                                        <div className={`${bookmark ? style.e_bookmark_active : ""} ${bookMarkLoader ? "pe-none" : ""} e-padding-8px-tb-10px-lr-res d-flex align-items-center gap-1 e-bg-white cursor-pointer border-radius-20 padding-12px-all overflow-hidden`}
                                            onClick={_handleBookmark}>
                                            <Icon icon={bookmark === true ? "bookmark-active" : "bookmark"}
                                                className="d-flex w-16px w-12px-res"
                                                color={Colors.ocean_blue}
                                                size="1rem"
                                            />
                                            {bookmarkText === true && bookmark === true &&
                                                <span className={`${bookmark ? style.e_bookmark_active_span : ""} d-none d-sm-block text-truncate e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-400 line-height-16px`}>
                                                    Saved to Watchlist!
                                                </span>
                                            }
                                        </div>

                                        {/* Share */}
                                        {/* <div className='position-relative'>
                                            <div className='e-bg-white border-radius-20 e-padding-8px-tb-10px-lr-res padding-12px-all cursor-pointer'
                                                onClick={_handleToggleShare}>
                                                <Icon icon={"share"}
                                                    className="d-flex w-16px w-12px-res"
                                                    color={Colors.outer_space}
                                                    size="1rem" />
                                            </div>

                                            {toggleShare &&
                                                <>
                                                    <OverLay isOpen={toggleShare} onClose={_handleToggleShare} />
                                                    <div className={`${style.e_share_modal_wrapper} e-bg-white border-radius-16 p-3 w-300px w-280px-res position-absolute end-0 top-48px z-index-999`}>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <h4 className='mb-0 e-primary-font-clash-display e-text-chinese-black e-font-14 e-font-weight-500 line-height-24px'>
                                                                Share basket via
                                                            </h4>
                                                            <Icon icon="close-icon"
                                                                size="20px"
                                                                className="d-flex cursor-pointer"
                                                                onPress={_handleToggleShare} />
                                                        </div>

                                                        <div className='pt-3 d-flex gap-3 flex-wrap e-border-bottom-2px-anti-flash-white pb-3'>
                                                            {SHARE_ITEMS.map((share, key) => (
                                                                <div key={key} className='text-center'>
                                                                    <img src={share.icon}
                                                                        draggable={false}
                                                                        className='w-24px-res'
                                                                        alt='e-mail' />
                                                                    <p className='mb-0 pt-1 e-alt-font-lato e-text-slate-gray e-font-10 e-font-weight-400 line-height-18px'>
                                                                        {share.label}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className='padding-12px-top'>
                                                            <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                                Copy link
                                                            </p>
                                                            <div className='position-relative'>
                                                                <CustomTextInput placeholder="https://example.com/invite?ref=1D"
                                                                    type="text"
                                                                    require
                                                                    value={link}
                                                                    error={linkError}
                                                                    padding="padding-40px-left padding-12px-right py-sm-3 py-2"
                                                                    className="w-100 bg-transparent"
                                                                    handleChange={(e) => setLink(e)} />
                                                                <img src={require("../../Assets/Images/Other/copy-icon.svg").default}
                                                                    draggable={false}
                                                                    className='position-absolute top-50 translate-middle-y left-16px'
                                                                    alt='copy' />
                                                            </div>

                                                            <PrimaryButton name="Copy"
                                                                className="mt-4 "
                                                                padding={`${style.e_copy_btn} padding-32px-lr e-padding-8px-tb-12px-lr-res`}
                                                                onPress={_handleCopyLink} />
                                                        </div>
                                                    </div>
                                                </>

                                            }
                                        </div> */}
                                    </div>

                                </div>
                                <div className='ms-auto col col-md-9'>
                                    <div className='d-none d-md-flex align-items-center gap-3 justify-content-end'>
                                        {/* bookmark */}
                                        <div className={`${bookmark ? style.e_bookmark_active : ""} ${bookMarkLoader ? "pe-none" : ""} d-flex align-items-center gap-1 e-bg-white cursor-pointer border-radius-20 padding-12px-all overflow-hidden`}
                                            onClick={_handleBookmark}>
                                            <Icon icon={bookmark === true ? "bookmark-active" : "bookmark"}
                                                className="d-flex"
                                                color="#523FC0"
                                                size="1rem" />
                                            {bookmarkText === true && bookmark === true &&
                                                <span className={`${bookmark ? style.e_bookmark_active_span : ""} text-truncate e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-400 line-height-16px`}>
                                                    Saved to Watchlist!
                                                </span>
                                            }
                                        </div>

                                        {/* Share basket  */}
                                        {/* <div className='position-relative'>
                                            <div className='e-bg-white border-radius-20 padding-12px-all cursor-pointer'
                                                onClick={_handleToggleShare}>
                                                <Icon icon={"share"}
                                                    className="d-flex"
                                                    color="#48464C"
                                                    size="1rem" />
                                            </div>
                                            {toggleShare &&
                                                <>
                                                    <OverLay isOpen={toggleShare} onClose={_handleToggleShare} />
                                                    <div className={`${style.e_share_modal_wrapper} e-bg-white border-radius-16 p-3 w-300px position-absolute end-0 top-48px z-index-999`}>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <h4 className='mb-0 e-primary-font-clash-display e-text-chinese-black e-font-14 e-font-weight-500 line-height-24px'>
                                                                Share basket via
                                                            </h4>
                                                            <Icon icon="close-icon"
                                                                size="20px"
                                                                className="d-flex cursor-pointer"
                                                                onPress={_handleToggleShare} />
                                                        </div>

                                                        <div className='pt-3 d-flex gap-3 flex-wrap e-border-bottom-2px-anti-flash-white pb-3'>
                                                            {SHARE_ITEMS.map((share, key) => (
                                                                <div key={key} className='text-center'>
                                                                    <img src={share.icon}
                                                                        draggable={false}
                                                                        alt='e-mail' />
                                                                    <p className='mb-0 pt-1 e-alt-font-lato e-text-slate-gray e-font-10 e-font-weight-400 line-height-18px'>
                                                                        {share.label}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className='padding-12px-top'>
                                                            <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                                Copy link
                                                            </p>
                                                            <div className='position-relative'>
                                                                <CustomTextInput placeholder="https://example.com/invite?ref=1D"
                                                                    type="text"
                                                                    require
                                                                    value={link}
                                                                    error={linkError}
                                                                    padding="padding-40px-left padding-12px-right py-3"
                                                                    className="w-100 bg-transparent"
                                                                    handleChange={(e) => setLink(e)} />
                                                                <img src={require("../../Assets/Images/Other/copy-icon.svg").default}
                                                                    draggable={false}
                                                                    className='position-absolute top-18px left-16px'
                                                                    alt='copy' />
                                                            </div>

                                                            <PrimaryButton name="Copy"
                                                                className="mt-4 "
                                                                padding={`${style.e_copy_btn} padding-32px-lr `}
                                                                onPress={_handleCopyLink} />
                                                        </div>
                                                    </div>
                                                </>

                                            }
                                        </div> */}
                                    </div>
                                    <div className='col-auto mt-sm-3 d-flex gap-4 gap-sm-5 flex-wrap e-bg-magnolia px-4 padding-20px-tb border-radius-8'>
                                        <div>
                                            <p className='e-font-14-res mb-1 e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-18px'>
                                                Objective
                                            </p>
                                            <p className='e-font-14-res mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-20px'>
                                                {basketData.objective || "--"}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='e-font-14-res mb-1 e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-18px'>
                                                Benchmark Index
                                            </p>
                                            <p className='e-font-14-res mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-20px'>
                                                {basketData.strategy_benchmark || "--"}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='e-font-14-res mb-1 e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-18px'>
                                                {basketData.returns.label}
                                            </p>
                                            <p className={`${basketData.returns.value < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-14-res mb-0 e-alt-font-lato  e-font-16 e-font-weight-600 line-height-20px`}>
                                                {basketData.returns.value_str}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='e-font-14-res mb-1 e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-18px'>
                                                Min. Investment
                                            </p>
                                            {
                                                basketData.min_investment &&
                                                <p className='e-font-14-res mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-20px'>
                                                    ₹{basketData.min_investment.toLocaleString("en-IN")}
                                                </p>
                                            }
                                        </div>
                                        <div>
                                            <p className='e-font-14-res mb-1 e-alt-font-lato e-text-primary-color e-font-16 e-font-weight-600 line-height-18px'>
                                                Risk type
                                            </p>
                                            <Chip label={basketData.risk_category_info?.risk_category_name}
                                                className={basketData.risk_category_info?.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                                    basketData.risk_category_info?.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                                        'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tags */}
                            {
                                basketData.tag &&
                                <div className='pt-3'>
                                    <h6 className='mb-2 e-alt-font-lato e-text-white e-font-14 e-font-weight-600 line-height-18px'>
                                        Investment Strategies
                                    </h6>
                                    <Chip label={basketData.tag}
                                        className="e-text-chinese-black e-border-0-5px-gainsboro e-bg-lavender-light" />
                                </div>
                            }
                        </div>

                        <div className='px-2 py-4'>
                            <div className='row row-gap-4'>

                                <div className='col-12 col-md-8'>
                                    <div className='d-flex gap-40px e-border-1px-bottom-lavender-light flex-nowrap overflow-hidden no-scrollbar'>
                                        {
                                            TAB_DATA.map((tab, key) => (

                                                <div key={key} //e-border-2px-bottom-ocean-blue
                                                    className={`${tabIndex === tab.id ? "active-tab border-radius-tlr-4 pe-none" : "cursor-pointer"} ${key === 2 && basketData.holdings.length == 0 ? "pe-none opacity-50 " : ""} e-padding-10px-bottom-res  padding-14px-bottom d-flex gap-1 align-items-center`}
                                                    onClick={() => _handleTab(tab.id)}>
                                                    <img src={tab.icon}
                                                        draggable={false}
                                                        alt='icon' />
                                                    <p className='e-font-14-res mb-0 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-500 line-height-20px'>
                                                        {tab.label}
                                                    </p>
                                                </div>
                                            ))}
                                    </div>
                                    {tabIndex === 1 ?
                                        // Overview
                                        <Overview data={basketData}
                                            subscription={subscription}
                                            handleSubscribe={_handleSubscribe} />
                                        :
                                        // Performance
                                        tabIndex === 2 ?
                                            <>
                                                {
                                                    performanceLoader ?
                                                        <Loader wrapperClassName="margin-100px-top" />
                                                        :
                                                        <>
                                                            {
                                                                chartData &&
                                                                <Performance data={chartData}
                                                                    benchmark={basketData.strategy_benchmark}
                                                                    subscription={subscription}
                                                                    cagrPerformance={cagrPerformance.data}
                                                                    handleSubscribe={_handleSubscribe} />
                                                            }
                                                        </>
                                                }
                                            </>
                                            :
                                            // Holding
                                            <>
                                                {
                                                    holdingsLoader ?
                                                        <Loader wrapperClassName="margin-100px-top" />
                                                        :
                                                        <Holdings chartData={holdingsBreakdownData}
                                                            holdings={basketData.holdings}
                                                            marketCap={basketData.market_cap}
                                                            subscription={subscription}
                                                            handleSubscribe={_handleSubscribe} />
                                                }
                                            </>
                                    }
                                </div>

                                {/* Subscription card */}
                                <div className='col-12 col-md-4'>
                                    <div className={`${style.e_subscription_card} ${showDatePicker === false ? "position-sticky top-0" : ""} border-radius-16 padding-20px-tb px-3`}>
                                        {
                                            (subscription === false || basketData.subscription_status !== "ACTIVE") ?
                                                <>
                                                    <h6 className='mb-3 e-primary-font-clash-display e-text-primary-color e-font-16 e-font-weight-600 line-height-20px'>
                                                        PRICING DETAILS
                                                    </h6>

                                                    {/* Select plan */}
                                                    {
                                                        basketData.pricing_information.length > 1 ?
                                                            <div className="d-flex flex-column gap-3">
                                                                {
                                                                    basketData.pricing_information.map((plan) => (
                                                                        <div className={`${selectedPlanID === plan.id ? "e-border-primary-active" : "e-border-1px-anti-flash-white"} ${basketData.subscribed_plan?.id && selectedPlanID !== plan.id ? "opacity-75 pe-none" : ""} d-flex gap-12px align-items-center bg-white p-2  border-radius-8 cursor-pointer`}
                                                                            onClick={() => _handleSelectPlan(plan.id)}>
                                                                            {/* Radio btn */}
                                                                            <Icon icon={selectedPlanID === plan.id ? "radio-active" : "radio-inactive"}
                                                                                size="16px"
                                                                                className="d-flex" />
                                                                            <div>
                                                                                <img src={require("../../Assets/Images/Basket/subscription-img.webp")}
                                                                                    draggable={false}
                                                                                    width={50}
                                                                                    height={50}
                                                                                    alt='subscription' />
                                                                            </div>
                                                                            <div>
                                                                                <p className='mb-1 e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                                                    Subscription plan
                                                                                </p>
                                                                                <p className='mb-0 e-primary-font-clash-display e-text-primary-color e-font-14-res e-font-16 e-font-weight-500 line-height-24px'>
                                                                                    {plan.fee_text}*
                                                                                    <span className={`${plan.fee_type === "FIXED" ? "" : "d-block"} e-font-12 e-alt-font-lato line-height-18px text-nowrap`}>
                                                                                        {plan.fee_type === "FIXED" ? "/ " : ""}
                                                                                        {plan.duration_text}
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            <div className="d-flex gap-12px align-items-center">
                                                                <div>
                                                                    <img src={require("../../Assets/Images/Basket/subscription-img.webp")}
                                                                        draggable={false}
                                                                        width={70}
                                                                        height={70}
                                                                        alt='subscription' />
                                                                </div>
                                                                <div>
                                                                    <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-20px'>
                                                                        Subscription plan
                                                                    </p>
                                                                    <p className='mb-0 e-primary-font-clash-display e-text-primary-color e-font-14-res e-font-16 e-font-weight-500 line-height-24px'>
                                                                        {basketData.pricing_information[0].fee_text}*
                                                                        <span className={`${basketData.pricing_information[0].fee_type === "FIXED" ? "" : "d-block"} e-font-12 e-alt-font-lato line-height-18px text-nowrap`}>
                                                                            {basketData.pricing_information[0].fee_type === "FIXED" ? "/ " : ""}
                                                                            {basketData.pricing_information[0].duration_text}
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                    }

                                                    {/*  HOW IT WORKS */}
                                                    <div className='pt-4 '>
                                                        <div className='d-flex align-items-center justify-content-between px-3 padding-14px-tb e-bg-white border-radius-8 cursor-pointer'
                                                            onClick={_handleToggle}>
                                                            <p className='mb-0 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-500 line-height-20px'>
                                                                HOW IT WORKS
                                                            </p>
                                                            <Icon icon="drop-down-icon"
                                                                size="14px"
                                                                color="#141514"
                                                                className={`${howItWorks === true ? 'e-rotate-180 ' : ''} transition d-flex`} />
                                                        </div>

                                                        {howItWorks &&
                                                            <div className={`${howItWorks ? style.e_how_it_active : ''} overflow-hidden pt-3`}>
                                                                {HOW_IT_WORKS.map((data, key) => (
                                                                    <div key={key}>
                                                                        <p className='my-2 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-500 line-height-18px'>
                                                                            STEP {key + 1}
                                                                        </p>

                                                                        <div className='d-flex align-items-start gap-2 e-border-bottom-1px-anti-flash-white pb-3'>
                                                                            <img src={require("../../Assets/Images/Other/kyc-verification.svg").default}
                                                                                draggable={false}
                                                                                alt='verification' />

                                                                            <div>
                                                                                <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-20px'>
                                                                                    {data.title}
                                                                                </p>
                                                                                <p className='mb-0 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-20px'>
                                                                                    {data.description}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        }
                                                    </div>

                                                    <p className='cursor-pointer padding-20px-top mb-3 e-alt-font-lato e-text-primary-color e-font-14 e-font-weight-600 line-height-16px'
                                                        onClick={() => setShowWhySubscriptionModal(true)}>
                                                        Why is Subscription Required?
                                                    </p>
                                                    {/* Subscribe button */}
                                                    <PrimaryButton name={(basketData.agreement_status === "MANDATE EXPIRED" || basketData.agreement_status === "AUTHORIZED") ? "Setup AutoPay" : basketData.subscription_status == "AUTO_RENEWAL" ? "Subscription in progress" : "Subscribe"}
                                                        status={loader}
                                                        disabled={loader || basketData.subscription_status === "AUTO_RENEWAL"}
                                                        className="w-100 h-48"
                                                        onPress={_handleSubscribe} />
                                                </>
                                                :
                                                <>
                                                    <h6 className='mb-3 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-20px'>
                                                        Investment Type
                                                    </h6>

                                                    {/* Custom radio */}
                                                    <div className='d-flex gap-3 pb-4'>
                                                        {investmentType.map((data, key) => (
                                                            <div key={key}>
                                                                <CustomRadioButton data={data}
                                                                    selected={selectedInvestmentType}
                                                                    handleSelect={_handleSelectInvestmentType} />
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {
                                                        selectedInvestmentType === 1 ?
                                                            <>
                                                                {/* SIP amount  */}
                                                                <CustomAmountInput label="SIP amount"
                                                                    placeholder="Enter sip amount"
                                                                    require
                                                                    prefix="₹"
                                                                    padding="padding-10px-tb ps-4"
                                                                    value={sipAmount}
                                                                    error={sipAmountError}
                                                                    className="w-100 bg-transparent"
                                                                    handleChange={_handleSIPAmountChange} />

                                                                {/* Amount chip */}
                                                                <div className='d-flex gap-1 padding-20px-top  flex-wrap'>
                                                                    {SIP_AMOUNT.map((amount, key) => (
                                                                        <p key={key} className={`${selectedAmountChip === amount.id ? 'e-border-0-5-ocean-blue' : 'e-border-0-5-light-silver'} mb-0 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-500 line-height-16px border-radius-24 py-2 padding-12px-lr e-bg-white cursor-pointer`}
                                                                            onClick={() => _handleSelectAmount(1, amount)}>
                                                                            +₹{amount.amount}
                                                                        </p>
                                                                    ))}
                                                                </div>

                                                                {/* SIP date picker  */}
                                                                {
                                                                    isSIPDue === false &&
                                                                    <CustomDatePicker label={isSIPDue ? "Monthly SIP" : "Monthly SIP (12 Installments)"}
                                                                        placeholder="Choose a date"
                                                                        require
                                                                        overlay
                                                                        padding="padding-12px-tb  padding-10px-lr"
                                                                        selected={selectedDate}
                                                                        toggle={showDatePicker}
                                                                        error={sipDateError}
                                                                        startDate={new Date()}
                                                                        minDate={new Date()}
                                                                        maxDate={addDays(new Date(), 30)}
                                                                        wrapperClass="mt-2"
                                                                        handleToggle={_handleToggleSIPDatePicker}
                                                                        handleClose={_handleCloseDatePicker}
                                                                        handleClear={_handleClearDate}
                                                                        handleSelect={_handelSIPDateSelect} />
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {/* Lumpsum amount  */}
                                                                <CustomAmountInput label="Total amount"
                                                                    placeholder="Enter amount"
                                                                    require
                                                                    prefix="₹"
                                                                    padding="padding-10px-tb ps-4"
                                                                    value={totalAmount}
                                                                    error={totalAmountError}
                                                                    className="w-100 bg-transparent"
                                                                    handleChange={(e) => setTotalAmount(e)} />

                                                                {/* Amount chip */}
                                                                <div className='d-flex gap-1 padding-20px-top pb-3 flex-wrap'>
                                                                    {SIP_AMOUNT.map((amount, key) => (
                                                                        <p key={key} className={`${selectedAmountChip === amount.id ? 'e-border-0-5-ocean-blue' : 'e-border-0-5-light-silver'} mb-0 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-500 line-height-16px border-radius-24 py-2 padding-12px-lr e-bg-white cursor-pointer`}
                                                                            onClick={() => _handleSelectAmount(2, amount)}>
                                                                            +₹{amount.amount}
                                                                        </p>
                                                                    ))}
                                                                </div>
                                                            </>
                                                    }

                                                    {
                                                        selectedInvestmentType == 1 ?

                                                            <>
                                                                <PrimaryButton name={isSIPDue ? "SIP Due" : "Start SIP"}
                                                                    status={sipLoader}
                                                                    type={basketData.executed === true ? 1 : 2} // type 2 ==> no disable feature
                                                                    disabled={sipLoader || basketData.executed === false || portfolioData.portfolio_id === undefined || repairHoldings.length !== 0 || disableStartSIP}
                                                                    className="w-100 margin-14px-top h-48 mb-1"
                                                                    onPress={_handleInvest} />
                                                                {
                                                                    basketData.executed === false &&
                                                                    <p className="e-alt-font-lato e-text-outer-space e-font-12 e-font-weight-400 line-height-14px">
                                                                        To start a SIP, invest in this basket in lumpsum
                                                                    </p>
                                                                }
                                                            </>
                                                            :
                                                            <PrimaryButton name={basketData.executed || basketData.portfolio_id ? "Invest more" : "Invest"}
                                                                status={loader}
                                                                disabled={loader || basketData.holdings.length == 0 || isSIPDue === true || basketData.subscription_status !== "ACTIVE" || repairHoldings.length !== 0}
                                                                className="w-100  h-48"
                                                                onPress={_handleInvest} />
                                                    }


                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Subscription status modal */}
                        {
                            subscriptionModal === true &&
                            <SubscriptionStatusModal
                                handleSuccess={_handleVerifyKYC}
                                handleClose={() => setSubscriptionModal(false)} />
                        }

                        {/* Why Subscription info modal */}
                        {
                            showWhySubscriptionModal === true &&
                            <WhySubscriptionModal
                                handleClose={() => setShowWhySubscriptionModal(false)} />
                        }

                        {/* Broker connect broker */}
                        {
                            showBrokerConnectModal &&
                            <ConnectBrokerModal type={1}
                                handleClose={_handleCloseConnectModal}
                                handleSuccess={_handleNavigateToBrokerConnect} />
                        }
                    </section>
            }
        </>
    )
}

export default BasketDetail;
